import React from "react";
import { ImageLoader } from "./ImageSkeletonLoader.styles";
import { SkeletonLoader } from "@ubnt/ui-components";

export const ImageSkeletonLoader = ({
  isVisible,
}: Readonly<{ isVisible: boolean }>) => {
  return (
    <ImageLoader $isVisible={isVisible}>
      <SkeletonLoader />
    </ImageLoader>
  );
};
